import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import Table from '../../../components/Table'
import { metodoPrograma } from '../../../components/api'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip as TooltipChat,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  TooltipChat,
  Legend,
)

const RelatorioAtendimento = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [lista, setLista] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [setDados] = useState(null)
  const [datasets, setDatasets] = useState([])
  const [labels, setLabels] = useState([])

  const getIndicadores = useCallback(() => {
    metodoPrograma('indicadorConveio', {
      idLocalAtendimento: localAtendimento[0],
    }).then((res) => {
      if (res.status) {
        setDatasets(res.datasets)
        setLabels(res.labels)
      }
    })
  }, [localAtendimento])

  const getList = useCallback(() => {
    metodoPrograma('lista', { idLocalAtendimento: localAtendimento[0] }).then(
      (res) => {
        if (res.status) {
          setLista(res.lista)
        }
      },
    )
  }, [localAtendimento])

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
    getList()
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  useEffect(() => {
    if (localAtendimento) {
      getList()
      getIndicadores()
    }
  }, [localAtendimento, getList, getIndicadores])

  // Dados do gráfico
  const data = {
    labels,
    datasets,
  }

  // Configurações do gráfico
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Atendiemntos por Convênio',
      },
    },
  }

  return (
    <Programa codigo="CtrlRelatorioAtendimento" ferramentas={ferramentas}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Bar data={data} options={options} height={80} />
        </Grid>
        <Grid item xs={12}>
          <Table
            dados={lista}
            head={['Paciente', 'Data', 'Situação', '']}
            line={(item) => [item[2], item[1], item[4], '']}
          />
        </Grid>
      </Grid>
    </Programa>
  )
}

export default RelatorioAtendimento
